<!--Footer-->
<footer class="page-footer text-center font-small trakly2 darken-2 mt-4 wow fadeIn">
  <!--Call to action-->
  <!-- <div class="pt-4">
            <a class="btn btn-outline-white" href="https://mdbootstrap.com/getting-started/" target="_blank" role="button">Download MDB
                <mdb-icon fas icon="download" class="ml-2"></mdb-icon>
            </a>
            <a class="btn btn-outline-white" href="https://mdbootstrap.com/bootstrap-tutorial/" target="_blank" role="button">Start free tutorial
                <mdb-icon fas icon="graduation-cap" class="ml-2"></mdb-icon>
            </a>
        </div> -->
  <!--/.Call to action-->

  <!-- <hr class="my-4"> -->

  <!-- Social icons -->
  <!-- <div class="pb-4">
            <a href="https://www.facebook.com/mdbootstrap" target="_blank">
                <mdb-icon fab icon="facebook-f" class="mr-3"></mdb-icon>
            </a>

            <a href="https://twitter.com/MDBootstrap" target="_blank">
                <mdb-icon fab icon="twitter" class="mr-3"></mdb-icon>
            </a>

            <a href="https://www.youtube.com/watch?v=7MUISDJ5ZZ4" target="_blank">
                <mdb-icon fab icon="youtube" class="mr-3"></mdb-icon>
            </a>

            <a href="https://plus.google.com/u/0/b/107863090883699620484" target="_blank">
                <mdb-icon fab icon="google-plus-g" class="mr-3"></mdb-icon>
            </a>

            <a href="https://dribbble.com/mdbootstrap" target="_blank">
                <mdb-icon fab icon="dribbble" class="mr-3"></mdb-icon>
            </a>

            <a href="https://pinterest.com/mdbootstrap" target="_blank">
                <mdb-icon fab icon="pinterest" class="mr-3"></mdb-icon>
            </a>

            <a href="https://github.com/mdbootstrap/bootstrap-material-design" target="_blank">
                <mdb-icon fab icon="github" class="mr-3"></mdb-icon>
            </a>

            <a href="http://codepen.io/mdbootstrap/" target="_blank">
                <mdb-icon fab icon="codepen" class="mr-3"></mdb-icon>
            </a>
        </div> -->
  <!-- Social icons -->

  <!--Copyright-->
  <div class="footer-copyright py-3">
    © {{ copyrightDate | date: "yyyy" }} Copyright:
    <a href="https://trakly.co.za" target="_blank"> Trakly (Pty) Ltd </a>
    <br />
    {{ env.appVersion }}
  </div>
  <!--/.Copyright-->
</footer>
<!--/.Footer-->
